import { FC } from 'react';

import { DotsLoaderStyled } from './DotsLoader.styled';

const DotsLoader: FC = () => <DotsLoaderStyled />;
export default DotsLoader;
